/**
 * Enquiry Form Hidden Field Injector
 *
 * Injects hidden fields into Shopify Forms app forms on product-enquiry template pages.
 * The hidden fields include:
 * - product_url: The full URL of the product page
 * - product_title: The title of the product being enquired about
 */
(function() {
  'use strict';

  // Get product data from the page
  let productData = window.productEnquiryData; // Injected by Liquid

  // Fallback if Liquid data is not available
  if (!productData) {
    productData = {
      url: window.location.href,
      title: document.title.replace(' – Contractor Essentials', '').trim(),
      handle: window.location.pathname.split('/').pop().split('?')[0]
    };
  }

  /**
   * Injects hidden fields into a form element
   * @param {HTMLFormElement} form - The form to inject fields into
   */
  function injectHiddenFields(form) {
    // Check if we've already injected (prevent duplicates)
    if (form.querySelector('input[name="properties[Product URL]"]')) {
      return;
    }

    // Create hidden field for product URL
    const urlField = document.createElement('input');
    urlField.type = 'hidden';
    urlField.name = 'properties[Product URL]';
    urlField.value = productData.url;
    form.appendChild(urlField);

    // Create hidden field for product title
    const titleField = document.createElement('input');
    titleField.type = 'hidden';
    titleField.name = 'properties[Product Name]';
    titleField.value = productData.title;
    form.appendChild(titleField);

    console.log('[Enquiry Form] Hidden fields injected:', {
      url: productData.url,
      title: productData.title
    });
  }

  /**
   * Finds and processes Shopify Forms app forms
   */
  function processFormsAppForms() {
    // Look for Shopify Forms app containers
    const formContainers = document.querySelectorAll('[data-shopify-form], .shopify-form, form[action*="forms"]');

    formContainers.forEach(container => {
      if (container.tagName === 'FORM') {
        injectHiddenFields(container);
      } else {
        const forms = container.querySelectorAll('form');
        forms.forEach(injectHiddenFields);
      }
    });

    // Also check for forms inside Shopify app blocks
    const allForms = document.querySelectorAll('form');
    allForms.forEach(form => {
      const isAppBlock = form.closest('[id*="shopify-block"]') ||
                         form.closest('[class*="shopify-app"]') ||
                         form.closest('.shopify-section');

      const isNotSystemForm = !form.closest('cart-drawer') &&
                              !form.closest('cart-form') &&
                              !form.classList.contains('cart') &&
                              !form.action?.includes('/cart') &&
                              !form.action?.includes('/search');

      if (isAppBlock && isNotSystemForm) {
        injectHiddenFields(form);
      }
    });
  }

  /**
   * Sets up a MutationObserver to watch for dynamically loaded forms
   */
  function observeForForms() {
    const observer = new MutationObserver((mutations) => {
      let shouldProcess = false;

      mutations.forEach(mutation => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.tagName === 'FORM' || node.querySelector?.('form')) {
                shouldProcess = true;
              }
            }
          });
        }
      });

      if (shouldProcess) {
        clearTimeout(window._enquiryFormTimeout);
        window._enquiryFormTimeout = setTimeout(processFormsAppForms, 100);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      processFormsAppForms();
      observeForForms();
    });
  } else {
    processFormsAppForms();
    observeForForms();
  }

  // Also try again after a delay for slow-loading app blocks
  setTimeout(processFormsAppForms, 1000);
  setTimeout(processFormsAppForms, 3000);
})();
